export const figure8 = {
chart: {
type: 'column',
backgroundColor: 'rgba(255, 255, 255, 0.0)',		   
},
title: {
text: ''
},
exporting: {
enabled: false
},
credits: {
enabled: false
},
xAxis: {
categories: ['Mundo', 'Asia central y Asia meridional', 'Asia oriental y Asia sudoriental', 'América Latina y el Caribe', 'América septentrional y Europa', 'Oceanía', 'África subsahariana', 'Asia occidental y África septentrional'],
labels: {
y: 40
}
},
yAxis: {
allowDecimals: false,
min: 0,
max: 80,
tickInterval: 10,
title: {
text: 'Porcentaje'
},
stackLabels: {
enabled: true,
verticalAlign: 'bottom',
crop: false,
overflow: 'none',
y: 20,
formatter: function () {
	       return this.stack;
       },
       style: {
	       fontSize: '9px',
	       fontWeight: 'normal',
	       color: '#6b6a6a'

       }
}
},
legend: {
enabled: false,
},
tooltip: {
formatter: function () {
		   var y_value = (this.y / 1).toString().replace('.', ',');
		   return this.series.userOptions.stack + ', ' + this.x + '<br/>'+ this.series.name + '' + ': <b>' + y_value + '%</b>';
},

},
plotOptions: {
column: {
stacking: 'normal'
}
},



series: [{
name: 'Inseguridad alimentaria grave',
color: '#C22E0C',
data: [12.8, 20.9, 1.9, 14.4, 1.2, 2.3, 27.6, 9.8],
stack: 'Rural',
index: 2

},
{
name: 'Inseguridad alimentaria grave',
color: '#C22E0C',
data: [11.6, 19.7, 1.6, 12.6, 1.3, 3.4, 26.3, 10.0],
// showInLegend: false,
stack: 'Periurbana',
linkedTo: ':previous',
index: 2

},
{
name: 'Inseguridad alimentaria grave',
color: '#C22E0C',
data: [9.4, 17.1, 1.0, 10.1, 1.4, 2.6, 23.0, 11.0],
// showInLegend: false,
stack: 'Urbana',
linkedTo: ':previous',
index: 2
},
{
name: 'Inseguridad alimentaria moderada',
color: '#F39200',
data: [20.5, 20.3, 11.4, 26.0, 5.6, 7.3, 40.5, 24.1],
stack: 'Rural',

index: 1

}, {
name: 'Inseguridad alimentaria moderada',
data: [17.2, 19.9, 6.6, 26.0, 5.2, 10.2, 42.0, 22.7],
color: '#F39200',
// showInLegend: false,
linkedTo: ':previous',
stack: 'Periurbana',
index: 1
},
{
name: 'Inseguridad alimentaria moderada',
data: [16.6, 21.0, 6.1, 22.1, 6.1, 8.5, 39.5, 20.6],
color: '#F39200',
// showInLegend: false,
linkedTo: ':previous',
stack: 'Urbana',
index: 1
},
]



};